/** Public marketing / homepage stats — no PII */
export const HERO_ROTATING_TAGLINES = [
    'Licensed therapy in naira',
    'Mood tracking & daily support',
    'Crisis resources when you need them',
];
//# sourceMappingURL=marketing.js.map